export const Skeleton = ({ className }: { className: string }) => {
    return <div className={`bg-account-border/80 animate-pulse rounded-lg ${className}`} />
}
